<template>
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_814_14489)">
      <path
        d="M12.2285 7.00391C15.8285 7.00391 19.0285 8.90391 20.8285 12.0039C21.0285 12.3039 21.0285 12.7039 20.8285 13.0039C19.1285 16.1039 15.8285 18.0039 12.2285 18.0039C8.62852 18.0039 5.42852 16.1039 3.62852 13.0039C3.42852 12.7039 3.42852 12.3039 3.62852 12.0039C5.42852 8.90391 8.62852 7.00391 12.2285 7.00391ZM12.2285 5.00391C7.42852 5.00391 3.22852 7.90391 1.42852 12.1039C1.32852 12.4039 1.32852 12.6039 1.42852 12.9039C3.22852 17.1039 7.42852 20.0039 12.2285 20.0039C17.0285 20.0039 21.2285 17.1039 23.0285 12.9039C23.1285 12.6039 23.1285 12.3039 23.0285 12.1039C21.2285 7.90391 17.1285 5.00391 12.2285 5.00391ZM11.6285 10.1039C13.5285 9.70391 15.1285 11.3039 14.6285 13.1039C14.4285 14.0039 13.7285 14.7039 12.8285 14.9039C10.9285 15.3039 9.32852 13.7039 9.82852 11.9039C10.0285 11.0039 10.7285 10.3039 11.6285 10.1039ZM13.4285 8.20391C10.0285 7.30391 7.02852 10.3039 7.92852 13.7039C8.32852 15.2039 9.52852 16.4039 11.0285 16.8039C14.4285 17.7039 17.5285 14.7039 16.6285 11.2039C16.2285 9.80391 14.9285 8.60391 13.4285 8.20391Z"
        fill="#86879D"
      />
    </g>
    <defs>
      <clipPath id="clip0_814_14489">
        <rect
          width="21.8"
          height="15"
          fill="white"
          transform="translate(1.32812 5.00391)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
